import clsx from 'clsx';
import styles from './DoubleValue.module.scss';
interface Props {
  label: string;
  value?: string;
  subValue?: string;
  title?: string;
}
export const DoubleValue = ({ label, value, subValue, title }: Props) => {
  return (
    <div className={styles.container} title={title}>
      <p className={styles.label}>{label}</p>
      <p
        className={clsx(styles.value, {
          [styles.no_data]: !value,
        })}
      >
        {value ? value : <>&mdash;</>}
      </p>
      <p
        className={clsx(styles.subValue, {
          [styles.no_data]: !subValue,
        })}
      >
        {subValue ? subValue : <>&mdash;</>}
      </p>
    </div>
  );
};
